@for(item of tickets(); track $index) {
  <ion-item lines="none"
    color="light"
    button="true"
    (click)="onTicket(item)">
    <ion-avatar slot="start">
      @if (item.preview$ | async; as preview) {
        <img [src]="preview" />
      } @else {
        <ion-icon name="image-outline"></ion-icon>
      }
    </ion-avatar>
    <div class="full-width">
      <ion-label>
        {{ item.name | translateTicket | async }}
      </ion-label>
      <div class="flex-justify-between">
        <span>{{ 'kanban.statusTitle' | translate }}:
          {{ 'kanban.status.' + item.status | translate }}
        </span>
        <span>{{ 'site.commercial.company' | translate }}:
          @if (item.contractor) {
            {{ item.contractor.name }}
          } @else {
            {{ 'general.notSelected' | translate }}
          }
        </span>
        <span>

        </span>
      </div>
    </div>
  </ion-item>
}